import React from 'react'

const Footer:React.FC = () => {
    return (
        <footer>
            <p>Copyright 2022</p>
        </footer>
    )
}

export default Footer
